module.exports = __webpack_public_path__ + "static/media/abd-add-w-feet-close.152a195f.png";